// extracted by mini-css-extract-plugin
export default {"imageHover":"AboutPage_imageHover__uL+SN","heading":"AboutPage_heading__sWLkG","subheading":"AboutPage_subheading__aKlEI","text":"AboutPage_text__iX8fn"};